import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndTextArea from '../common/form/labelAndTextarea';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';
import ListaAutoSuggestManual from '../common/form/ListaAutoSuggestManual';
import ConfirmModal from '../common/modal/confirmModal';

import {
	setModoTela, initForm, alterarComposicao, gerarPdfFicha,
	setModoTelaChecklist, initFormChecklist, inicializarChecklist, getListaChecklist, salvarChecklist,
	salvarSaida, salvar,
	salvarOrdemServicoFicha
} from './controlePatioActions';
import InputAssinatura from '../common/form/inputAssinatura';
import ThSort from '../common/table/thSort';

class ControlePatioForm extends Component {

	state = {

	}

	async componentDidMount() {
		this.props.getListaChecklist();
	}
	
	componentWillUnmount() {
		
	}

	render() {

		let readOnly = this.props.excluir || this.props.historico ? 'readOnly' : '';

		let pendenciasBloqueiaSaida = [
			...(this.props.formularioValues.fichas_setores || []).filter(ficha => !ficha.finalizada && ficha.obrigatoria).map(ficha => `Aguardando ${ficha.nome}`),
			...(this.props.formularioValues.listaPendenciaMotorista || []).filter(pendencia => !pendencia.resolvida && pendencia.obrigatoria).map(pendencia => `Aguardando ${pendencia.nome_setor} - ${pendencia.nome_tipo}`)
		];
		

		if (!this.props.formularioValues.checklist_respondido) {
			pendenciasBloqueiaSaida.push('Checklist não respondido');
		}

		if (!this.props.formularioValues.assinatura_motorista_saida) {
			pendenciasBloqueiaSaida.push('Motorista não assinou');
		}
		
		const bloqueiaSaida = pendenciasBloqueiaSaida.length > 0;

		const mudouComposicao = this.props.formularioValues.cavalo_base != this.props.formularioValues.cavalo
			|| this.props.formularioValues.carreta1_base != this.props.formularioValues.carreta1
			|| this.props.formularioValues.carreta2_base != this.props.formularioValues.carreta2
			|| this.props.formularioValues.id_motorista_base != this.props.formularioValues.id_motorista;

		const usuarioRecepcao = !!this.props.listaSetor.filter(item => item.id == 7 && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(item.permissao)).length; //7 - Recepção
		const usuarioCCO = !!this.props.listaSetor.filter(item => item.id == 5 && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(item.permissao)).length; //5 - CCO

		return (
			<>

				{this.state.confirmacao &&
				<ConfirmModal
					visible={this.state.confirmacao}
					titulo='Confirmação'
					mensagem={this.state.confirmacao.mensagem}
					textoConfirmar='Sim'
					textoCancelar='Cancelar'
					onConfirm={this.state.confirmacao.eventoSim}
					onCancel={this.state.confirmacao.eventoCancelar}
				/>}

				<ContentCard>

					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>
								<Field
									name='id'
									component={LabelAndInput}
									label='Número'
									cols='12 1 1 1'
									minWidth={100}
									placeholder='Selecione'
									readOnly={'readOnly'} />

								<div style={{ width: 210, marginTop: 8, marginLeft: 8 }}>
									<a class='btn btn-app bg-warning' style={{ marginLeft: 2, minWidth: 75 }}
										onClick={() => {
											this.props.setModoTela('lista');
										}}>
										<i class='fas fa-arrow-left'></i> Voltar
									</a>
									<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
										onClick={() => {
											this.props.gerarPdfFicha([{ ...this.props.formularioValues }]);
										}}>
										<i class='fas fa-file-pdf'></i> Exportar
									</a>
								</div>
							</Row>
							<div class='card'>
								<div class='card-header'>
									<div class='d-flex justify-content-between'>
										<h3 class='card-title' style={{ fontWeight: 'bold' }}>Entrada</h3>
									</div>
								</div>
								<div class='card-body'>
									<Row>
										<Field
											name='cavalo_entrada'
											component={LabelAndInput}
											label='Cavalo'
											cols='12 1 1 1'
											minWidth={170}
											placeholder='Selecione'
											readOnly={'readOnly'} />

										<Field
											name='carreta1_entrada'
											component={LabelAndInput}
											label='Carreta1'
											cols='12 1 1 1'
											minWidth={170}
											placeholder='Selecione'
											readOnly={'readOnly'} />

										<Field
											name='carreta2_entrada'
											component={LabelAndInput}
											label='Carreta 2'
											cols='12 1 1 1'
											minWidth={170}
											placeholder='Selecione'
											readOnly={'readOnly'} />

										<Field
											name='nome_motorista_entrada'
											component={LabelAndInput}
											label='Motorista'
											cols='12 1 1 1'
											minWidth={350}
											placeholder='Selecione'
											readOnly={'readOnly'} />

										<LabelAndInput
											name='datahora_previsao_entrada'
											component={LabelAndInput}
											label='Previsão de Chegada' placeholder='Informe'
											cols='12 1 1 1'
											minWidth={175}
											readOnly={'readOnly'}
											value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_previsao_entrada)}
											onChange={() => { }} />

										<LabelAndInput
											label='Entrada'
											cols='12 1 1 1'
											readOnly={'readOnly'}
											minWidth={175}
											value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_entrada)}
											onChange={value => {
											}} />

										<Field
											name='odometro_entrada'
											component={LabelAndInput}
											label='Odômetro' placeholder=''
											cols='12 1 1 1'
											minWidth={120}
											readOnly={'readOnly'}
											casas={0} />

										<Field
											name='observacao_entrada'
											component={LabelAndTextArea}
											label='Observação' placeholder='Informe'
											cols='12 12 6 6'
											readOnly={'readOnly'} />

										<Grid cols='12 12 6 6'>
											<Row style={{  }}>
												<Grid cols='12 12 12 12' style={{ }}>
													<p style={{ fontSize: 16 }}>
														{this.props.formularioValues.termo_concordancia_entrada}
													</p>
												</Grid>
												<Grid cols='12 12 12 12'>
													<Row alignCenter style={{ marginTop: 12 }}>
														<img
															style={{
																border: '2px solid #000',
																backgroundColor: '#ffffff',
																width: 500,
																height: 100
															}}
															src={this.props.formularioValues.assinatura_motorista_entrada} />
													</Row>
												</Grid>
												<Grid cols='12 12 12 12' style={{ textAlign: 'center' }}>
													<label>{this.props.formularioValues.nome_motorista_entrada}</label>
												</Grid>
												{/*<Grid cols='12 12 12 12' style={{ textAlign: 'center' }}>
													<p><b>CPF:</b> {FormatUtils.formatarCPF(this.props.formularioValues.cpf_motorista_entrada)} | <b>CNH:</b> {this.props.formularioValues.cnh_motorista_entrada}</p>
												</Grid>*/}
											</Row>
										</Grid>
									</Row>
								</div>
							</div>
							<div class='card'>
								<div class='card-header'>
									<div class='d-flex justify-content-between'>
										<h3 class='card-title' style={{ fontWeight: 'bold' }}>Saída</h3>
									</div>
								</div>
								<div class='card-body'>
									<Row>
										<Field
											name='cavalo'
											options={this.props.listaCavalo}
											component={Select}
											label='Cavalo'
											cols='12 1 1 1'
											minWidth={170}
											placeholder='Selecione'
											readOnly={'readOnly'} />

										<Field
											name='carreta1'
											options={this.props.listaCarreta}
											component={Select}
											label='Carreta1'
											cols='12 1 1 1'
											minWidth={170}
											placeholder='Selecione' />

										<Field
											name='carreta2'
											options={this.props.listaCarreta}
											component={Select}
											label='Carreta 2'
											cols='12 1 1 1'
											minWidth={170}
											placeholder='Selecione' />
											
										<Field
											name='id_motorista'
											options={this.props.listaMotorista}
											component={Select}
											label='Motorista'
											cols='12 1 1 1'
											minWidth={350}
											placeholder='Selecione' />

										{!this.props.historico && [2, 3].includes(this.props.formularioValues.id_status) ? ( //No Pátio e Aguardando Saída
											<LabelAndInputDateTime
												label='Previsão de Saída'
												cols='8 1 1 1'
												readOnly={this.props.formularioValues.registrosEntradaConfirmados || !usuarioCCO ? 'readOnly' : readOnly}
												value={this.props.formularioValues.datahora_previsao_saida}
												onChange={value => {
													this.props.initForm({
														...this.props.formularioValues,
														datahora_previsao_saida: value
													});
												}} />
										) : (
											<LabelAndInput
												label='Previsão de Saída'
												cols='12 1 1 1'
												readOnly={'readOnly'}
												minWidth={175}
												value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_previsao_saida)}
												onChange={value => {
												}} />
										)}
											
										<Field
											name='observacao_saida'
											component={LabelAndTextArea}
											label='Observação' placeholder='Informe'
											cols='12 12 12 12' />
									</Row>
								</div>
							</div>
							
							{this.manutencao()}

							{this.fichas()}

							{this.checklist()}

							{this.props.formularioValues.checklist_respondido &&
							<>
							{this.props.formularioValues.id_status == 3 ? ( //Aguardando Saída
								<Row alignCenter>
									<Grid cols='12 12 8 8'>
										<p style={{ marginTop: 32, fontSize: 16 }}>
											Sr. Motorista, neste momento da saída do pátio da matriz, o caminhão retorna à sua responsabilidade integral, cabendo ao motorista a condução segura do veículo, bem como a conferência das condições gerais para início da viagem. Sendo assim, o motorista declara estar ciente das condições do veículo e apto a prosseguir com o transporte, assumindo a responsabilidade a partir deste momento até o destino final.
										</p>
									</Grid>
									<Grid cols='12 12 12 12'>
										<Row alignCenter style={{ marginTop: 24 }}>
											<InputAssinatura
												idUploadAssinatura={`inputAssinatura_motorista_saida`}
												label={`Assinatura do Motorista`}
												value={this.props.formularioValues.assinatura_motorista_saida}
												semGaleria
												onChange={(assinatura) => {
													this.props.initForm({
														...this.props.formularioValues,
														assinatura_motorista_saida: assinatura,
														termo_concordancia_saida: 'Sr. Motorista, neste momento da saída do pátio da matriz, o caminhão retorna à sua responsabilidade integral, cabendo ao motorista a condução segura do veículo, bem como a conferência das condições gerais para início da viagem. Sendo assim, o motorista declara estar ciente das condições do veículo e apto a prosseguir com o transporte, assumindo a responsabilidade a partir deste momento até o destino final.',
														datahora_assinatura_motorista_saida: DateFormat.getDataHoraAtual()
													});
												}} />
										</Row>
									</Grid>
									<Grid cols='12 12 12 12' style={{ textAlign: 'center' }}>
										<label>{this.props.formularioValues.nome_motorista_saida}</label>
									</Grid>
									{/*<Grid cols='12 12 12 12' style={{ textAlign: 'center', marginBottom: 24 }}>
										<p><b>CPF:</b> {this.props.formularioValues.cpf_motorista} | <b>CNH:</b> {this.props.formularioValues.cnh_motorista}</p>
									</Grid>*/}
								</Row>
							) : (
								<Row alignCenter>
									<Grid cols='12 12 8 8'>
										<p style={{ marginTop: 32, fontSize: 16 }}>
											{this.props.formularioValues.termo_concordancia_saida}
										</p>
									</Grid>
									<Grid cols='12 12 12 12'>
										<Row alignCenter style={{ marginTop: 24 }}>
											<img
												style={{
													border: '2px solid #000',
													backgroundColor: '#ffffff',
													width: 500,
													height: 100
												}}
												src={this.props.formularioValues.assinatura_motorista_saida} />
										</Row>
									</Grid>
									<Grid cols='12 12 12 12' style={{ textAlign: 'center' }}>
										<label>{this.props.formularioValues.nome_motorista}</label>
									</Grid>
									{/*<Grid cols='12 12 12 12' style={{ textAlign: 'center', marginBottom: 24 }}>
										<p><b>CPF:</b> {FormatUtils.formatarCPF(this.props.formularioValues.cpf_motorista)} | <b>CNH:</b> {this.props.formularioValues.cnh_motorista}</p>
									</Grid>*/}
								</Row>
							)}
							</>}
							
							{!this.props.historico &&
							<Row alignCenter>
								{bloqueiaSaida && 
								<div class='callout callout-danger'>
									<h5>Existem Pendências!</h5>
									<p>Resolva para permitir a saída do pátio</p>
									{pendenciasBloqueiaSaida.map(pendencia => (
										<p key={pendencia} style={{ margin: 0, padding: 0 }}> - {pendencia}</p>
									))}
								</div>}
							</Row>}
						</ContentCardBody>
						<ContentCardFooter>						

							{!this.props.historico &&
							<Row alignCenter>

								{(usuarioCCO && [2, 3].includes(this.props.formularioValues.id_status)) && //No Pátio e Aguardando Saída
								<Grid cols='6 6 4 3'>
									<Button
										text='Alterar Previsão de Saída'
										type={'success'}
										icon={'fa fa-check'}
										event={() => {
											this.props.salvar({
												...this.props.formularioValues
											});
										}} />
								</Grid>}

								{mudouComposicao && 
								<Grid cols='6 6 4 3'>
									<Button
										text='Alterar Composição'
										type={'success'}
										icon={'fa fa-check'}
										event={() => {
											this.props.alterarComposicao({
												...this.props.formularioValues
											});
										}} />
								</Grid>}
								{(this.props.formularioValues.id_status == 3 && !bloqueiaSaida && !mudouComposicao && usuarioRecepcao) &&
								<Grid cols='6 6 4 3'>
									<Button
										text='Confirmar Saída do Pátio'
										type={'success'}
										icon={'fa fa-check'}
										event={() => {
											this.setState({
												confirmacao: {
													mensagem: 'Deseja realmente realizar a saída do pátio?',
													eventoSim: () => {
														this.props.salvarSaida({
															...this.props.formularioValues
														});
														this.setState({
															confirmacao: null
														});
													},
													eventoCancelar: () => {
														this.setState({
															confirmacao: null
														});
													}
												}
											});
											
										}} />
								</Grid>}
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.setModoTela('lista')} />
								</Grid>
							</Row>}
							{this.props.historico &&
							<Row alignCenter>
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.setModoTela('lista')} />
								</Grid>
							</Row>}
						</ContentCardFooter>
					</Form>
				</ContentCard>

				{this.listaLogs()}
			
			</>
		);
	}

	manutencao() {

		const usuarioOficina = !!this.props.listaSetor.filter(item => item.id == 3 && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(item.permissao)).length; //3 - Oficina

		const lista = [{
			id_ficha: this.props.formularioValues.id_ficha_cavalo,
			placa: this.props.formularioValues.cavalo,
			ordem_servico: this.props.formularioValues.ordem_servico_cavalo,
			tipo: 'Cavalo'
		}, {
			id_ficha: this.props.formularioValues.id_ficha_carreta1,
			placa: this.props.formularioValues.carreta1,
			ordem_servico: this.props.formularioValues.ordem_servico_carreta1,
			tipo: 'Carreta 1'
		}, {
			id_ficha: this.props.formularioValues.id_ficha_carreta2,
			placa: this.props.formularioValues.carreta2,
			ordem_servico: this.props.formularioValues.ordem_servico_carreta2,
			tipo: 'Carreta 2'
		}].filter(item => item.id_ficha);

		return (
			<>
				<Row>
					{lista.map(item => {

						const manutencoes = (this.props.formularioValues.lista_manutencao || []).filter(manutencao => manutencao && manutencao.id_controle_patio_ficha == item.id_ficha);
						
						return (
							<Grid cols='12 4 4 4' key={item.id_ficha}>
								<div class='card'>
									<div class='card-header'>
										<div class='d-flex justify-content-between'>
											<h3 class='card-title' style={{ fontWeight: 'bold' }}>{item.tipo}: {item.placa}</h3>
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 5
												}}
											>
												{this.state.editandoOrdemServicoFicha == item.id_ficha ? (
													<input
														type='text'
														class='form-control form-control-sm'
														style={{
															height: 28,
															width: 120,
															fontSize: 14
														}}
														value={this.state.ordem_servico}
														autoFocus
														onChange={e => {
															this.setState({
																ordem_servico: e.target.value
															});
														}}
														onKeyDown={e => {
															if (e.key === 'Escape') {
																this.setState({
																	editandoOrdemServicoFicha: null,
																	ordem_servico: ''
																});
															}

														}}
													/>
												) : (
													<span
														style={{
															fontSize: 14,
															color: '#666',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
															whiteSpace: 'nowrap'
														}}
														title={item.ordem_servico || ''}
													>
														{item.ordem_servico ? `OS: ${item.ordem_servico}` : 'Sem OS'}
													</span>
												)}
												{usuarioOficina &&
												<button
													type='button'
													class={
														this.state.editandoOrdemServicoFicha == item.id_ficha
															? 'btn btn-success btn-sm'
															: 'btn btn-secondary btn-sm'
													}
													style={{
														width: 28,
														height: 28,
														padding: 0,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center'
													}}
													title={
														this.state.editandoOrdemServicoFicha == item.id_ficha
															? 'Salvar'
															: 'Editar'
													}
													onClick={() => {

														if (this.state.editandoOrdemServicoFicha == item.id_ficha) {

															// SALVAR AQUI
															this.props.salvarOrdemServicoFicha({
																id: item.id_ficha,
																ordem_servico: this.state.ordem_servico
															});

															this.props.initForm({
																...this.props.formularioValues,
																ordem_servico_cavalo: item.tipo == 'Cavalo' ? this.state.ordem_servico : this.props.formularioValues.ordem_servico_cavalo,
																ordem_servico_carreta1: item.tipo == 'Carreta 1' ? this.state.ordem_servico : this.props.formularioValues.ordem_servico_carreta1,
																ordem_servico_carreta2: item.tipo == 'Carreta 2' ? this.state.ordem_servico : this.props.formularioValues.ordem_servico_carreta2,
															});

															this.setState({
																editandoOrdemServicoFicha: null,
																ordem_servico: ''
															});
														} else {

															this.setState({
																editandoOrdemServicoFicha: item.id_ficha,
																ordem_servico: item.observacao || ''
															});

														}

													}}
												>
													<i
														class={
															this.state.editandoOrdemServicoFicha == item.id_ficha
																? 'fas fa-check'
																: 'fas fa-pencil-alt'
														}
													></i>
												</button>}
											</div>
										</div>
									</div>
									<div class='card-body'>
										{manutencoes.map((manutencao, pos) => (
											<Row key={manutencao.id}>
												<Grid cols='12 12 12 12'>
													<p>{pos + 1} - {manutencao.descricao}</p>
												</Grid>
											</Row>
										))}
									</div>
								</div>
							</Grid>
						);
					})}
				</Row>
			</>
		)
	}

	fichas() {

		return (
			<Row>
				<Grid cols='12 12 12 12'>
					<div class='card'>
						<div class='card-body'>
							<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap' }}>
								{(this.props.formularioValues.fichas_setores || []).map(ficha => {

									const fichaSelecionada = (this.state.registroFichas ? this.state.registroFichas.idsFichas || [] : []).includes(ficha.id_setor)
										|| (this.state.registroFichas ? this.state.registroFichas.idsFichas || [] : []).includes(ficha.id_setor_pai);

									let cor = null;
									if (ficha.quantidade == ficha.executadas) {
										cor = fichaSelecionada ? '#075e01' : '#087d00';
									} else if (ficha.obrigatoria) {
										cor = fichaSelecionada ? '#706f6f' : '#949191';
									} else {
										cor = fichaSelecionada ? '#706f6f' : '#949191';
									}

									return (
										<div className='controle-patio-button-hover'
											key={ficha.id_setor}
											style={{
												backgroundColor: cor,
												color: '#ffffff'
											}}
											onClick={() => {
												this.eventoFichas(ficha);												
											}} >
											<i class={ficha.icone} style={{ marginRight: 4 }}></i>
											{ficha.nome}: {ficha.quantidade == ficha.executadas ? 'OK' : (`${ficha.executadas} de ${ficha.quantidade}`)}
										</div>
									);
								})}
							</div>
						</div>
						{this.registroFicha()}
					</div>
				</Grid>
			</Row>
		);
	}

	eventoFichas(ficha) {

		let idsFichas = this.state.registroFichas ? this.state.registroFichas.idsFichas || [] : [];
		if (idsFichas.includes(ficha.id_setor)) {
			idsFichas = idsFichas.filter(idAux => idAux != ficha.id_setor);
		} else {
			idsFichas.push(ficha.id_setor);
		}
		if (ficha.id_setor_pai) {
			if (idsFichas.includes(ficha.id_setor_pai)) {
				idsFichas = idsFichas.filter(idAux => idAux != ficha.id_setor_pai);
			} else {
				idsFichas.push(ficha.id_setor_pai);
			}
		}
		
		let listaPendencias = [];
		let listaFichas = [];

		if (idsFichas.includes(5) || idsFichas.includes(6) || idsFichas.includes(999)) {
			//Pendência
			listaPendencias = [...this.props.formularioValues.listaPendenciaMotorista, ...this.props.formularioValues.listaPendenciaDemais].map(pendencia => ({
				id: pendencia.id,
				nome_setor: pendencia.nome_setor,
				nome: pendencia.nome_motorista || pendencia.cavalo || pendencia.carreta || pendencia.shipping,
				nome_status: pendencia.nome_status,
				nome_tipo: pendencia.nome_tipo,
				observacao: pendencia.observacao,
				bloqueia_saida: pendencia.bloqueia_saida,
				data_maxima: pendencia.data_maxima,
				resolvida: pendencia.resolvida,
				cor: pendencia.resolvida ? '#087d00' : (
					pendencia.bloqueia_saida ? '#949191' : '#949191'
				)
			}))
		}
		if (idsFichas.filter(idAux => idAux != 5 && idAux != 6).length) {
			//Ficha
			listaFichas = (this.props.formularioValues.fichas_setores_completa || []).filter(itemFicha => itemFicha && idsFichas.includes(itemFicha.id_setor)).map(itemFicha => ({
				id: itemFicha.id,
				nome_setor: itemFicha.nome_setor,
				id_controle_patio_ficha: itemFicha.id_controle_patio_ficha,
				nome: ficha.nome_motorista || itemFicha.cavalo || itemFicha.carreta,
				datahora_fim: itemFicha.datahora_fim,
				datahora_inicio: itemFicha.datahora_inicio,
				datahora_liberacao: itemFicha.datahora_liberacao,
				obrigatoria: itemFicha.obrigatoria,
				cor: itemFicha.datahora_liberacao || itemFicha.datahora_fim ? '#087d00' : (
					itemFicha.obrigatoria ? '#949191' : '#949191'
				),
				lista_eventos: itemFicha.lista_eventos
			}))
		}

		if (this.state.registroFicha && this.state.registroFicha.id == ficha.id) {
			this.setFichas(null);
		} else {
			this.setFichas({
				idsFichas: idsFichas,
				nome: ficha.nome,
				listaPendencias: listaPendencias.length ? listaPendencias : null,
				listaFichas: listaFichas.length ? listaFichas : null,
				listaManutencoes: (this.props.formularioValues.lista_manutencao || []).filter(manutencao => manutencao)
			});
		}
	}

	pendencias() {

		if (!(this.props.formularioValues.listaPendencias || []).length) {
			return null;
		}

		return (
			<Row>
				{this.props.formularioValues.listaPendencias.map(item => (
					<Grid key={item.id} cols='12 6 4 4'>
						<div class={`alert ${item.obrigatoria ? 'alert-danger' : 'alert-warning'} alert-dismissible`}>
							<h5><i class={item.obrigatoria ? 'icon fas fa-ban' : 'icon fas fa-exclamation-triangle'}></i> {item.nome_setor}{item.obrigatoria ? ' (obrigatória)': ''}</h5>
							<p>{item.nome_tipo}</p>
							<p>{item.nome_tipo_ficha}: {item.nome_motorista || item.cavalo || item.carreta}</p>
						</div>
					</Grid>
				))}
			</Row>
		);
	}

	checklist() {

		if (!this.props.formularioValues.checklist_respondido) {
			return (
				<Row>
					<Grid cols='12 12 12 12'>
						<div class='card'>
							<div class='card-body'>
								<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap' }}>
									<div className='controle-patio-button-hover'
										style={{
											backgroundColor: '#949191',
											color: '#ffffff',
											paddingLeft: 24,
											paddingRight: 24,
											paddingTop: 8,
											paddingBottom: 8,
											margin: 4,
											borderRadius: 8,
											fontSize: 16
										}}
										onClick={() => {

											window.location = `/#controlePatioChecklist`;

											setTimeout(() => {

												this.props.inicializarChecklist({
													...this.props.formularioValues,
													idOrigemControlePatio: this.props.formularioValues.id
												});

											}, 200);

										}}>
										<i class='fas fa-tasks' style={{ marginRight: 4 }}></i>
										Checklist Pendente
									</div>
								</div>
							</div>
						</div>
					</Grid>
				</Row>
			);
		}

		return (
			<Row>
				<Grid cols='12 12 12 12'>
					<div class='card'>
						<div class='card-body'>
							<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap' }}>
								<div className='controle-patio-button-hover'
									style={{
										backgroundColor: '#087d00',
										color: '#ffffff'
									}}
									onClick={() => {
										this.props.initForm({
											...this.props.formularioValues,
											checklistExpandido: !this.props.formularioValues.checklistExpandido
										});
									}} >
									<i class='fas fa-tasks' style={{ marginRight: 4 }}></i>
									Checklist Respondido
								</div>
							</div>

							{this.props.formularioValues.checklistExpandido &&
								<Row>
									<Grid cols='12 12 12 12'>
										<table style={{ width: '100%' }}>
											<thead>
												<tr style={{ height: 60 }}>
													<th width={10}>Checklist</th>
													<th width={10}></th>
													<th width={10}></th>
													<th width={1000}>Observação</th>
												</tr>
											</thead>
											<tbody>
												{(this.props.formularioValues.lista_checklist || []).map((pergunta, i) => {
													return (
														<tr key={pergunta.id}
															style={{
																backgroundColor: i % 2 == 0 ? '#1F3066' : '#2b3d7aff'
															}}>
															<td style={{ minWidth: 180, paddingLeft: 12, verticalAlign: 'middle', color: '#ffffff', fontWeight: 'bold' }}>{pergunta.nome_pergunta}</td>
															<td style={{ verticalAlign: 'middle' }}>
																<LabelAndInput
																	label={null}
																	cols='12 12 12 12'
																	minWidth={160}
																	value={pergunta.resposta}
																	readOnly={'readOnly'}
																	onChange={data => {
																	}} />
															</td>
															<td style={{ verticalAlign: 'middle' }}>
																<div class='btn-group btn-group-toggle' style={{ marginTop: 4 }}>
																	<label class={`btn ${pergunta.id_resposta == 1 ? 'bg-success active' : 'bg-light'}`}>
																		<input type='radio' name='options1' id='option_b1' autocomplete='off' checked='' readOnly={'readOnly'}
																			onChange={() => {
																			}} /> Sim
																	</label>
																	<label class={`btn ${pergunta.id_resposta == 2 ? 'bg-olive active' : 'bg-light'}`}>
																		<input type='radio' name='options2' id='option_b2' autocomplete='off' readOnly={'readOnly'}
																			onChange={() => {
																			}} /> Indif.
																	</label>
																	<label class={`btn ${pergunta.id_resposta == 3 ? 'bg-danger active' : 'bg-light'}`}>
																		<input type='radio' name='options3' id='option_b3' autocomplete='off' readOnly={'readOnly'}
																			onChange={() => {
																			}} /> Não
																	</label>
																</div>
															</td>
															<td style={{ verticalAlign: 'middle' }}>
																<LabelAndInput
																	label={null}
																	cols='12 12 12 12'
																	readOnly={'readOnly'}
																	value={pergunta.observacao}
																	onChange={data => {
																	}} />
															</td>
														</tr>
													)
												})}
											</tbody>
										</table>
									</Grid>
								</Row>}
						</div>
					</div>
				</Grid>
			</Row>
		)
	}

	setFichas(registro) {
		this.setState({
			registroFichas: registro
		});
	}

	registroFicha() {

		if (!this.state.registroFichas) {
			return;
		}

		const registro = this.state.registroFichas;

		const possuiManutencao = registro.listaManutencoes.filter(manutencao => registro.idsFichas.includes(manutencao.id_setor)).length > 0;

		return (
			<Row>
				<Grid cols='12 12 12 12'>
					{registro.listaFichas &&
						<Table responsive border striped>
							<THead>
								<Tr backgroundColor={'#1F3066'} color={'#ffffff'} height={47}>
									<ThSort field='setor' label='Setor' width={100} sticky />
									<ThSort field='nome' label='Nome' width={100} sticky />
									{possuiManutencao &&
									<ThSort field='listaManutencoes' label='Itens' width={100} sticky />}
									<ThSort field='status' label='Status' width={100} sticky />
									<ThSort field='obrigatoria' label='Obrigatória' width={10} sticky />
									<ThSort field='lista_eventos' label='Histórico' width={10} sticky />
								</Tr>
							</THead>
							<TBody>
								{registro.listaFichas.map((item, i) => {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td color={'#000'} alignCenter>
												{item.nome_setor}
											</Td>
											<Td color={'#000'} alignCenter>{item.nome}</Td>
											{possuiManutencao &&
												<Td color={'#000'} alignCenter>
													<div>
														{registro.listaManutencoes.filter(manutencao => manutencao.id_controle_patio_ficha == item.id_controle_patio_ficha).map((manutencao, pos) => (
															<div key={pos} style={{ fontSize: 13, display: 'flex', alignItems: 'center' }}>

																<label
																	key={pos}
																	style={{
																		fontSize: 16,
																		display: 'flex',
																		alignItems: 'center',
																		padding: '8px 4px',
																		cursor: 'pointer',
																		userSelect: 'none'
																	}}
																	disabled={true}
																>
																	<input
																		type='checkbox'
																		checked={!!manutencao.executado}
																		style={{
																			marginRight: 10,
																			width: 18,
																			height: 18,
																			cursor: 'pointer'
																		}}
																		disabled={true}
																	/>

																	<span
																		style={{
																			textDecoration: !manutencao.executado ? 'line-through' : 'none',
																			color: !manutencao.executado ? '#888' : '#000',
																			fontSize: 14
																		}}
																	>
																		{manutencao.descricao}
																	</span>
																</label>

															</div>
														))}
													</div>
												</Td>}
											<Td color={'#000'} alignCenter>
												{item.datahora_fim ? 'Finalizada' : (item.datahora_liberacao ? 'Liberada' : (item.datahora_inicio ? 'Iniciada' : 'Não Inciada'))}
											</Td>
											<Td color={'#000'} alignCenter>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
											<Td color={'#000'} alignCenter>
												<table style={{ width: '100%' }}>
													<tbody>
														{(item.lista_eventos || []).map(itemEvento => (
															<tr key={itemEvento.id}>
																<td width={100} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{itemEvento.nome_evento}</td>
																<td width={100} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{DateFormat.formatarDataHoraSqlParaTela(itemEvento.datahora)}</td>
																<td width={200} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{itemEvento.nome_usuario}</td>
															</tr>
														))}
													</tbody>
												</table>
											</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>}

					{registro.listaPendencias &&
						<Table responsive border striped>
							<THead>
								<Tr backgroundColor={'#1F3066'} color={'#ffffff'} height={47}>
									<ThSort field='setor' label='Setor' width={100} sticky />
									<ThSort field='nome' label='Nome' width={100} sticky />
									<ThSort field='nome_status' label='Status' width={100} sticky />
									<ThSort field='nome_tipo' label='Pendência' width={100} sticky />
									<ThSort field='observacao' label='Observação' width={100} sticky />
									<ThSort field='obrigatoria' label='Obrigatória' width={10} sticky />
									<ThSort field='data_maxima' label='Data Máxima' width={100} sticky />
								</Tr>
							</THead>
							<TBody>
								{registro.listaPendencias.map((item, i) => {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td color={'#000'} alignCenter>
												{item.nome_setor}
											</Td>
											<Td color={'#000'} alignCenter>{item.nome}</Td>
											<Td color={'#000'} alignCenter>{item.nome_status}</Td>
											<Td color={'#000'} alignCenter>{item.nome_tipo}</Td>
											<Td color={'#000'} alignCenter>{item.observacao}</Td>
											<Td color={'#000'} alignCenter>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
											<Td color={'#000'} alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_maxima)}</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>}
				</Grid>
			</Row >
		);
	}

	listaLogs() {

		if (!this.props.listaLog.length) {
			return null;
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<h3 class='card-title'>Logs</h3>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border striped>
						<THead>
							<Tr backgroundColor={'#1F3066'}
								color={'#ffffff'}
								height={47}>
								
								<ThSort field='datahora' label='Data/Hora' width={100} sticky />
								<ThSort field='operacao' label='Operação' width={100} sticky />
								<ThSort field='nome_status' label='Status' width={100} sticky />
								<ThSort field='cavalo' label='Cavalo' width={50} sticky />
								<ThSort field='carreta1' label='Carreta 1' width={50} sticky />
								<ThSort field='carreta2' label='Carreta 2' width={50} sticky />
								<ThSort field='nome_motorista' label='Motorista' width={200} sticky />
								<ThSort field='datahora_previsao_saida' label='Prev. Saída' width={100} sticky />
								<ThSort field='datahora_entrada' label='Entrada' width={100} sticky />
								<ThSort field='datahora_assinatura_motorista_entrada' label='Assinatura Entrada' width={100} sticky />								
								<ThSort field='datahora_saida' label='Saída' width={100} sticky />
								<ThSort field='datahora_assinatura_motorista_saida' label='Assinatura Saída' width={100} sticky />
								<ThSort field='nome_usuario' label='Usuário' width={200} sticky /> 
							</Tr>
						</THead>
						<TBody>
							{this.props.listaLog.map((item, i) => {
								return (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora)}</Td>
										<Td color={'#000'} alignCenter small>{item.operacao}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_status}</Td>
										<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
										<Td color={'#000'} alignCenter small>{item.carreta1}</Td>
										<Td color={'#000'} alignCenter small>{item.carreta2}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_motorista}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrada)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_assinatura_motorista_entrada)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_assinatura_motorista_saida)}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_usuario}</Td>										
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

}

ControlePatioForm = reduxForm({ form: 'controlePatioForm', destroyOnUnmount: false })(ControlePatioForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('controlePatioForm')(state),
	registro: state.controlePatio.registro,
	listaMotorista: state.controlePatio.listaMotorista,
	listaCavalo: state.controlePatio.listaCavalo,
	listaCarreta: state.controlePatio.listaCarreta,
	listaLog: state.controlePatio.listaLog,
	listaSetor: state.setor.listaSelect.filter(item => {
		return (item.ids_usuarios || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id);
	}).map(item => ({
		...item,
		permissao: (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id) ? 'GESTOR' : (
			(item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id) ? 'SUPERVISOR' : (
				(item.ids_usuarios || []).includes(state.auth.usuario.id) ? 'USUARIO' 
				: 'SEM PERMISSAO'
			)
		)
	}))
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, alterarComposicao, gerarPdfFicha,
	setModoTelaChecklist, initFormChecklist, inicializarChecklist, getListaChecklist, salvarChecklist,
	salvarSaida, salvar,
	salvarOrdemServicoFicha
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatioForm);